<!-- ==============================
  File Name: partnerCodesAdd.vue
  Description: Partner Codes Add page
=============================== -->
<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vx-card>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-6" v-if="!isPartner">
            <label class="font-sm">Select Partner*</label>
            <v-select
              :options="partners"
              :reduce="item => item.value" label="label"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              class="w-full"
              :value="Codes.Partner"
              v-validate="'required'"
              name="Partner"
              v-model="Codes.Partner"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('Partner') && isSaveForm"
            >{{ errors.first('Partner') }}.</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              class="w-full"
              name="CodeName"
              label-placeholder="Code Name*"
              v-validate="'required'"
              v-model="Codes.CodeName"
              :value="Codes.CodeName"
              @blur="checkCodename($event)"
              v-on:keyup="checkCode($event)"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('CodeName') && isSaveForm"
            >The Code Name field is required.</span>
            <span
              class="text-danger text-sm"
              v-if="isCodeExist || isPrimaryCodeExist"
            >Code name already exists.</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
             <flat-pickr :value="Codes.StartDate" v-validate="'required'" name="StartDate" :config="configFromdateTimePicker"  class="w-full mt-5" v-model="Codes.StartDate" placeholder="Start Date"/>
            <span
              class="text-danger text-sm"
              v-show="errors.has('StartDate') && isSaveForm"
            >The Start Date field is required.</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2" v-if="!isChecked">
             <flat-pickr :value="Codes.ExpiryDate" v-validate="'required'" name="ExpiryDate" :config="configTodateTimePicker"  class="w-full mt-5" v-model="Codes.ExpiryDate" placeholder="Expiry Date"/>
            <span
              class="text-danger text-sm"
              v-show="errors.has('ExpiryDate') && isSaveForm"
            >The Expiry Date field is required.</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2 mt-5">
            <label class="font-sm">Select Status</label>
            <v-select
              :options="statusList"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              class="w-full"
              name="Status"
              v-model="Codes.Status"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2 mt-5">
            <vs-checkbox v-model="isChecked">Primary</vs-checkbox>
          </div>
        </div>
        <div class="vx-row mt-5">
          <div class="vx-col w-full">
            <vs-button class="mr-3 mb-2" @click.prevent="saveCode">Save</vs-button>
            <vs-button
              color="warning"
              type="border"
              class="mb-2"
              @click.native="$router.push('/apps/partners/partnercodes/list')"
            >Cancel</vs-button>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import "@/assets/css/main.css";
import PartnerCodesService from "@/services/PartnerCodesService";
import PartnerService from "@/services/PartnerService";
import UtilService from "@/services/UtilService";
import vSelect from "vue-select";
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
export default {
  components: {
    "v-select": vSelect,
    flatPickr
  },
  data() {
    return {
      configFromdateTimePicker: {
        dateFormat: "Y-m-d h:i K",
      },
      configTodateTimePicker: {
        dateFormat: "Y-m-d 11:59 P\\M",
      },
      userZone : '',
      isChecked: false,
      oldPartnerValue: "",
      isCodeExist: false,
      isPrimaryCodeExist: false,
      isPartner: false,
      Codes: {
        Id: "",
        Partner: "",
        CodeName: "",
        StartDate: "",
        ExpiryDate: "",
        Primary: "No",
        IsDeleted: 0,
        CreatedBy: "",
        Status: "Active",
        ModifiedBy: ""
      },
      partners: [],
      statusList: ["Active", "InActive"],
      isSaveForm: false,
      oldCodeValue: "",
      partnerId: ""
    };
  },
  methods: {
    checkCodename(event) {
      if (event.target.value !== "") {
        PartnerCodesService.checkDuplicateCode(event.target.value, (isExists) => {
          if(isExists != null){
            this.isPrimaryCodeExist = isExists;
          }
        });
      } else {
        this.isPrimaryCodeExist = false;
      }
    },

    checkCode(e) {
      e.target.value = e.target.value.toUpperCase();
      let char = String.fromCharCode(e.keyCode);
      if (/[A-Za-z0-9]/.test(char)) return true;
      else e.preventDefault();
    },
    fetchPartnercodeData(codeId) {
      PartnerCodesService.getById(codeId).once("value", item => {
        if (item && item.val()) {
          this.Codes = item.val();
          this.Codes['StartDate'] = this.Codes['StartDate'] ? UtilService.convertUTCToCurrentZone(this.Codes['StartDate'],this.userZone) : "";
          this.Codes['ExpiryDate'] = this.Codes['ExpiryDate'] ? UtilService.convertUTCToCurrentZone(this.Codes['ExpiryDate'],this.userZone) : "";
          this.Codes["Partner"] = this.Codes["Partner"]
            ? this.Codes["Partner"]
            : "";
          if (this.Codes["Primary"] == "Yes") {
            this.isChecked = true;
            this.Codes["ExpiryDate"] = "";
          }
          this.oldCodeValue = item.val()["CodeName"];
          PartnerCodesService.getPartnerName(this.Codes["Partner"]).on(
            "value",
            items => {
              items.forEach(item => {
                let partnerData = item.val();
                let partnerName = partnerData.CompanyName;
                this.Codes['Partner']= partnerName
                this.oldPartnerValue = this.Codes.Partner;
              });
            }
          );
        }
      });
    },
    saveCode() {
      this.isSaveForm = true;
      this.$validator.validateAll().then(result => {
        if (result && !this.isPrimaryCodeExist && !this.isCodeExist) {
          this.Codes["CreatedBy"] = this.userInfo["Id"];
          let partnerCodeObj = { ...this.Codes };
          if (this.isChecked) {
            partnerCodeObj["Primary"] = "Yes";
            partnerCodeObj["ExpiryDate"] = "";
          } else {
            partnerCodeObj["Primary"] = "No";
          }
          if (
            new Date(partnerCodeObj["StartDate"]) >
            new Date(partnerCodeObj["ExpiryDate"])
          ) {
            UtilService.notifyErrorAlert(
              this.$vs,
              "Start Date can not be before Expiry date."
            );
            return;
          }
          else if(partnerCodeObj['Primary'] === 'No' && (partnerCodeObj['ExpiryDate'] && new Date(partnerCodeObj['ExpiryDate']) < new Date())){
            UtilService.notifyErrorAlert(this.$vs, "Expiry date can not be in past.");
            return;
          }
          if (partnerCodeObj["Id"]) {
            if (this.isPartner) {
              partnerCodeObj["Partner"] = this.userInfo.PartnerId;
            } else {
              if (typeof partnerCodeObj["Partner"] === "object") {
                partnerCodeObj["Partner"] = partnerCodeObj["Partner"].value;
              }
              PartnerService.getPartnerByName(partnerCodeObj["Partner"]).once(
                "value",
                items => {
                  items.forEach(item => {
                    partnerCodeObj["Partner"] = item.val()["Id"];
                  });
                }
              );
            }

            if (partnerCodeObj["Partner"] != this.oldPartnerValue) {
              PartnerCodesService.decCodeCount(this.oldPartnerValue).then(
                obj => {
                  console.log("old partner value count updated successfully");
                }
              );
            }
            PartnerService.getPrimaryCode(this.oldCodeValue).once(
              "value",
              item => {
                item.forEach(item => {
                  PartnerService.updatePrimaryCode(
                    item.val()["Id"],
                    partnerCodeObj["CodeName"],
                    this.userInfo["Id"]
                  );
                });
              }
            );

            partnerCodeObj["ModifiedBy"] = this.userInfo["Id"];
            partnerCodeObj['StartDate'] = partnerCodeObj['StartDate']; //? UtilService.convertUserTimeZoneToUTC(partnerCodeObj['StartDate'],this.userZone) : "";
            partnerCodeObj['ExpiryDate'] = partnerCodeObj['ExpiryDate']; //? UtilService.convertUserTimeZoneToUTC(partnerCodeObj['ExpiryDate'],this.userZone) : "";
            PartnerCodesService.update(partnerCodeObj["Id"], partnerCodeObj)
              .then(() => {
                UtilService.notifySuccessAlert(
                  this.$vs,
                  "Code updated successfully."
                );
                this.$router.push("/apps/partners/partnercodes/list");
                this.fetchPartnercodeData(this.$route.params.codeId);
              })
              .catch(e => {
                console.log(e);
              });
          } else {
            if (this.isPartner) {
              partnerCodeObj["Partner"] = this.userInfo.PartnerId;
            } else {
              partnerCodeObj["Partner"] = partnerCodeObj["Partner"];
            }
            PartnerCodesService.checkDuplicateCode(partnerCodeObj.CodeName, (isExists) => {
              if(isExists === true){
                UtilService.notifyErrorAlert(this.$vs, "Code already exists.");
                console.log("Coming Here");
              } else {
                console.log("Date - ",UtilService.convertUserTimeZoneToUTC(partnerCodeObj['StartDate'],this.userZone));
                partnerCodeObj['StartDate'] = partnerCodeObj['StartDate'];// ? UtilService.convertUserTimeZoneToUTC(partnerCodeObj['StartDate'],this.userZone) : "";
                partnerCodeObj['ExpiryDate'] = partnerCodeObj['ExpiryDate'];// ? UtilService.convertUserTimeZoneToUTC(partnerCodeObj['ExpiryDate'],this.userZone) : "";
                PartnerCodesService.create(partnerCodeObj)
                  .then(obj => {
                    PartnerCodesService.incCodeCount(
                      partnerCodeObj["Partner"]
                    ).then(obj1 => {
                      UtilService.notifySuccessAlert(
                        this.$vs,
                        "Code created successfully."
                      );
                      this.$router.push("/apps/partners/partnercodes/list");
                    });
                  })
                  .catch(e => {
                    console.log(e);
                  });
              }
            })
          }
        }
      });
    },
    getPartnerVal() {
      PartnerCodesService.getPartnerVal().on("value", items => {
        this.partners = [];

        items.forEach(item => {
          let partnerVal = {};
          let key = item.key;
          let data = item.val();
          if (data["IsDeleted"] == 0) {
            partnerVal["label"] = data["CompanyName"];
            partnerVal["value"] = data["Id"];
            this.partners.push(partnerVal);
          }
        });
        this.partners.sort((a, b) => a.label.localeCompare(b.label))
      });
    },
    resetCode() {
      this.Codes = {
        Id: "",
        Partner: "",
        CodeName: "",
        StartDate: "",
        ExpiryDate: "",
        Primary: "No",
        IsDeleted: 0,
        CreatedBy: "",
        Status: "Active",
        ModifiedBy: ""
      };
    }
  },
  watch: {
    $route(to, from) {
      this.isSaveForm = false;
      this.resetCode();
    }
  },
  created() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo;
    this.userZone = this.userInfo.Timezone;
    this.resetCode();
    this.getPartnerVal();
    if (this.$route.params.codeId) {
      this.fetchPartnercodeData(this.$route.params.codeId);
    }

    if (
      this.userInfo.Role === "Partner Admin" ||
      this.userInfo.Role === "Partner Staff"
    ) {
      this.isPartner = true;
      this.Codes["Partner"] = this.userInfo.Company
        ? this.userInfo.Company
        : "";
    }
  }
};
</script>
